import { ModalTypes } from 'application/providers/ModalProvider/consts';

import { PlayerTypesInFlow } from './SelectPlayerModal/types';

export const MODAL_MODE_BY_DEVICE_TYPE: Record<PlayerTypesInFlow, ModalTypes> = {
  [PlayerTypesInFlow.WEBPLAYER]: ModalTypes.STREAM_BIND_SUCCESS,
  [PlayerTypesInFlow.MOBILE]: ModalTypes.MOBILE_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.BOOM_SPEAKER]: ModalTypes.SBERBOOM_REQUEST,
  [PlayerTypesInFlow.DESKTOP]: ModalTypes.DESKTOP_PLAYER_DOWNLOAD,
  [PlayerTypesInFlow.ANDROIDBOX]: ModalTypes.SBERBUSSINESS_REQUEST,
  [PlayerTypesInFlow.VIDEOPLAYER]: ModalTypes.CHOOSE_VIDEO_PLAYER,
};

export type UseSelectPlayerFlowControllerProps = {
  targetStreamId?: string;
  isTemplateMode: boolean;
  selectPlayerFlowType: SelectPlayerFlowType;
};

export enum SelectPlayerFlowType {
  CREATE_POINT = 'CREATE_POINT',
  CHANGE_DEVICE = 'CHANGE_DEVICE',
  BIND_STREAM = 'BIND_STREAM',
}

export interface OnboardingActionContextType {
  setInFlow: (inFlow: boolean) => void;
  setFlowType: (flowType: SelectPlayerFlowType) => void;
  setIsTemplateMode: (isTemplateMode: boolean) => void;
  resetState: () => void;
}

export interface OnboardingState {
  inFlow: boolean;
  flowType?: SelectPlayerFlowType;
  isTemplateMode: boolean;
}

export enum OnboardingActionTypes {
  SET_IN_FLOW = 'setInFlow',
  SET_FLOW_TYPE = 'setFlowType',
  SET_IS_TEMPLATE_FLOW = 'setIsTemplateMode',
  RESET_STATE = 'resetState',
}

export type OnboardingAction =
  | { type: OnboardingActionTypes.SET_IN_FLOW; inFlow: boolean }
  | { type: OnboardingActionTypes.SET_FLOW_TYPE; flowType: SelectPlayerFlowType }
  | { type: OnboardingActionTypes.SET_IS_TEMPLATE_FLOW; isTemplateMode: boolean }
  | { type: OnboardingActionTypes.RESET_STATE };
